function handleResponse(res) {
  if (res.status === 404) {
    res.json().then(() =>
      Promise.resolve({
        error: "No data",
      })
    );
  }
  if (res.status === 500) {
    return Promise.resolve({
      error: "An error occurred. We are working on it.",
    });
  }
  return res.json();
}

function handleDates(f) {
  const filters = { ...f };
  if (filters.billing === null) {
    delete filters.billing;
  }
  return {
    ...filters,
    startDate: filters.startDate.toISOString(),
    endDate: filters.endDate.toISOString(),
  };
}

function getQueryString(filters) {
  const metaParam = [];
  // convert filters object into a query string
  return `${Object.keys(filters)
    .map((key) => {
      if (key === "projectUUID") {
        if (filters[key]) {
          metaParam.push(`project:${filters[key]}`);
        }
        return "";
      }
      if (key === "broadcastUUID") {
        if (filters[key]) {
          metaParam.push(`broadcast:${filters[key]}`);
        }
        return "";
      }
      if (key === "inboundUUID") {
        if (filters[key]) {
          metaParam.push(`inbound:${filters[key]}`);
        }
        return "";
      }
      if (key === "eventUUID") {
        if (filters[key]) {
          metaParam.push(`event:${filters[key]}`);
        }
        return "";
      }
      if (key === "metaKind") {
        if (filters[key]) {
          metaParam.push(`kind:${filters[key]}`);
        }
        return "";
      }
      return `${key}=${filters[key]}`;
    })
    .join("&")}&withMetadata=1${
    metaParam.length > 0 ? `&meta=${metaParam.join(",")}` : ""
  }`;
}

// f is filters object from Filters component
export function getReportData(f) {
  const filters = handleDates(f);
  const queryString = getQueryString(filters);

  return fetch(`/reports/gateway/getGraphData?${queryString}`).then(
    handleResponse
  );
}
// https://dev.to/chandelieraxel/why-you-should-cancel-your-api-calls-in-react-410l
export function getTableData(f, controller) {
  const filters = handleDates(f);
  const queryString = getQueryString(filters);
  return fetch(
    `/reports/gateway/getTransactions?${queryString}`,
    controller && { signal: controller.signal }
  ).then(handleResponse);
}

export function getReplies({ transactionId, ...args }, controller) {
  const queryString = getQueryString(args);

  return fetch(
    `/reports/gateway/replies/${transactionId}?${queryString}`,
    controller && { signal: controller.signal }
  ).then(handleResponse);
}

async function refreshApiToken() {
  const response = await fetch("/api-gateway/get-new-token", {
    headers: { Accept: "application/json" },
  });
  if (response.status === 401) {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `/login?session-expired=true&return=${returnUrl}`;
    throw new Error("Session expired");
  }
  if (!response.ok) {
    throw new Error("Failed to refresh API token");
  }
  const data = await response.json();
  window.apiToken = data.token;
  return data.token;
}

export async function getBroadcastMessage(uuid, controller, retry = true) {
  const app = document.querySelector("#app");
  const { apiBase } = JSON.parse(app?.dataset?.page ?? "{}").props ?? {};
  const response = await fetch(
    `${apiBase}/logic/workflows/api/broadcast-messages/${uuid}`,
    {
      signal: controller?.signal,
      headers: { Authorization: `Bearer ${window.apiToken}` },
    }
  );
  if (response.status === 401 && retry) {
    await refreshApiToken();
    return getBroadcastMessage(uuid, controller, false);
  }
  if (!response.ok) {
    const data = await response.json();
    throw new Error(
      data.error || data.message || "Failed to fetch message snapshot"
    );
  }
  return response.json();
}

export function getRepliesByBroadcastMessage({ uuid, ...args }, controller) {
  const queryString = getQueryString(args);
  return fetch(
    `/reports/gateway/replies-by-broadcast-message/${uuid}?${queryString}`,
    controller && { signal: controller.signal }
  ).then(handleResponse);
}

export function getRepliesByMessageContext(
  { kind, value, channel, ...args },
  controller
) {
  const queryString = getQueryString({ ...args, comms: channel });
  return fetch(
    `/reports/gateway/replies-by-message-context/${kind}/${value}?${queryString}`,
    controller && { signal: controller.signal }
  ).then(handleResponse);
}

export async function getRelatedBroadcastMessage(context, controller, retry = true) {
  const app = document.querySelector("#app");
  const { apiBase } = JSON.parse(app?.dataset?.page ?? "{}").props ?? {};
  const query = new URLSearchParams({
    kind: context.kind,
    value: context.value,
    channel: context.channel,
  });
  const response = await fetch(
    `${apiBase}/logic/workflows/api/related-broadcast-message?${query.toString()}`,
    {
      signal: controller?.signal,
      headers: { Authorization: `Bearer ${window.apiToken}` },
    }
  );
  if (response.status === 401 && retry) {
    await refreshApiToken();
    return getRelatedBroadcastMessage(context, controller, false);
  }
  if (response.status === 404) return null;
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || data.message || "Failed to fetch message snapshot");
  }
  return response.json();
}
